// import { post } from "../utils/request";
import { ElMessage } from "element-plus";
import { fileTable } from "../data/FileBrowse";
import { post, uploadPost } from "../utils/request";
import { FILE_SPACE_BASE_DIR, MAX_IMPORT_TASK_TEMPLATE_SIZE, ROOT_ACCOUNT } from "../utils/utilData";


export default {
  name: "FileBrowse",
  data() {
    return {
      fileList: [],
      fileTable: fileTable,
      searchKeyWord: "",
      uploadFileList: [],
      role: parseInt(JSON.parse(sessionStorage.getItem("roleList"))[0].roleId),
    };
  },
  methods: {
    // 查询文件
    searchViewableFiles() {
      post("/file/viewable/search/batch",).then((res) => {
        if (res.code == 200) {
          this.fileList = JSON.parse(res.data.data);
        }
      });
    },
    handlePreview(file) {
      var a = document.createElement("a");
      var event = new MouseEvent('click');
      a.download = file.name;
      a.href = FILE_SPACE_BASE_DIR + '/viewable' + file.url;
      a.dispatchEvent(event);
    },
    // 下载文件
    handledownload(index, row) {
      this.handlePreview(row);
    },
    // 删除文件
    handleDelete(index, row) {
      post("/file/viewable/delete", JSON.stringify(row)).then((res) => {
        if (res.code == 200) {
          this.searchViewableFiles();
        }
      })
    },
    // 上传文件
    uploadFile(param) {
      let form = new FormData();
      form.append('file', param.file);
      form.append('userId', JSON.parse(sessionStorage.getItem("userInfo")).userId);
      uploadPost('/file/viewable/upload', form).then(res => {
        // 上传成功后把文件信息push进附件数组中
        this.fileList.push(JSON.parse(res.data.data));
        this.$refs.uploadFile.clearFiles();
      });
    },
    getUploadFile(file, fileList) {
      let allowedExtention = ["pdf", "doc", "docx", "jpg", "jpeg", "png", "rar", "zip"];
      let fileExtention = file.name.substring(file.name.lastIndexOf(".") + 1);
      // 限制文件上传类型
      if (allowedExtention.indexOf(fileExtention) === -1) {
        ElMessage.error("该文件类型不允许上传", {
          duration: 3 * 1000,
        });
        this.uploadFileList = [];
        return;
      }
      // 每次上传文件前都先将其清空
      this.uploadFileList = [];
      // this.file = file.raw;
      // 文件上传不能大于20M
      if (file.size / 1024 / 1024 > MAX_IMPORT_TASK_TEMPLATE_SIZE) {
        ElMessage.error("文件大小超过" + MAX_IMPORT_TASK_TEMPLATE_SIZE + "M, 不予上传", {
          duration: 3 * 1000,
        });
        this.uploadFileList = [];
        return;
      }
      // 每次上传就自动调用上传函数
      this.$refs.uploadFile.submit();
    },
  },
  computed: {
    fileListFilter() {
      return this.fileList.filter(data => !this.searchKeyWord || data.name.toLowerCase().includes(this.searchKeyWord.toLowerCase()))
    },
    fileAllowRole() {
      // root用户可以有新增和删除的权限
      let allowRoleArr = [ROOT_ACCOUNT];
      for (let i = 0; i < allowRoleArr.length; i++) {
        if (allowRoleArr[i] == this.role) {
          return true;
        }
      }
      return false;
    },
  },
  created() {
    this.searchViewableFiles();
  },
}